<template>
  <div
    class="sitebuilder-element-container"
    element="WebinarVideoComponent"
    :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile"
    :id="id"
    :config-properties="JSON.stringify(internal_config)"
    v-on:click="focusElement($event)"
    @contextmenu.prevent="handler($event)"
    :style="style()"
  >
    <vue-draggable-resizable
      v-bind:w="parseInt(internal_config.width)"
      v-bind:h="parseInt(internal_config.height)"
      @resizing="onResize" ref="draggableResizable"
      :draggable="false"
      :enable-native-drag="true"
    >
			<rotate :target="this.$refs.draggableResizable" :config="this.internal_config" />
			<sync-drag :target="this" />
      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-WebinarVideoComponent'></options-element-bar>

      <div class="divBlock" v-show="!this.preview"></div>

      <div class="embed-responsive embed-responsive-16by9" v-if="this.preview">
        <iframe :width="internal_config.width" :height="internal_config.height"
                :src="getUrl()"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen class="embed-responsive-item"
                v-bind:style="{'border-radius': radius,border : border}">
        </iframe>
      </div>
      <img v-if="!this.preview"
           class="preview-img"
           src="/static/images/webinar2.png"
           :width="internal_config.width" :height="internal_config.height"
           v-bind:style="{'border-radius': radius,border : border}">

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>
<script>

	import Model from './Model';
	import Resources from './Resources.vue';
  import OptionsElementBar from "../OptionsElementBar";

	export default {
		name: 'WebinarVideoComponent',
		components: {
      OptionsElementBar,
			Resources,
		},
		props: ['config', 'height_start', 'device', 'id', 'preview'],
		data() {
			return Model.data()
		},
    watch: {
      'internal_config': {
        deep: true,
        handler(value) {
          this.$eventHub.setValueElementConfig(this.id, value);
          this.$eventPointer.log(this.id, value);
        }
      },
    },

		computed: {
			width() {
				return this.internal_config.width;
			},
			height() {
				return this.internal_config.height;
			},
			border() {
				return this.internal_config.border;
			},
			radius() {
				return this.internal_config.borderRadius;
			},
		},
		methods: {
			animation() {
				return true;
			},
			getUrl() {

				let url = this.internal_config.src;
				url = url + 'embed.php?id=' + this.internal_config.webinarId + "&secret=" + this.internal_config.webinarSecret;
				return url;
			},

			onResize: function (x, y, width, height) {
				this.internal_config.width = width + 'px';
				this.internal_config.height = height + 'px';
				this.$refs.resourcesData.setValuesData(this);
			},
			focusElement(e) {
        this.$root.$emit("focusElement", this);
        this.$root.$emit('handlerElement', this);


        e.stopPropagation();
        e.preventDefault();
			},
			showResources() {
				return this.$refs.resourcesData.getValuesData();
			},

			//change order on html
			changeOrderPanel(elem, idx) {
        if (typeof this.$parent.changeOrderPanel !== 'undefined') {
          this.$parent.changeOrderPanel(this, idx);
        } else {
          this.$parent.$parent.changeOrderPanel(this, idx);
        }

			},
			handler: function (e) {
				// this.$el.classList.add('animated', 'jello', 'infinite');
				this.$root.$emit('focusElement', this);
				this.$root.$emit('handlerElement', this, true);
				e.stopPropagation();
				e.preventDefault();
			},
			style() {
				let style = `left:  ${this.internal_config.left};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     top: ${this.internal_config.top}`;
				return style;
			},

		},
		created() {
			let device, childs, id, config;
			({device, childs, id, config} = this.$props);
			this.internal_config = config;
			this.device = device;
			if (typeof id !== 'undefined') {
				this.id = id;
			}
			this.internal_config = window.mergeRecursive(this.props, this.$props.config);
		},
		mounted() {
			this.$refs.resourcesData.setValuesData(this);
			if (this.$props.preview) {
				this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
			}
			let objIds = [];
			$('[id]').each(function () {
				var ids = $('[id="' + this.id + '"]');
				if (ids.length > 1 && ids[0] == this && parseInt(this.id))
					objIds.push(this.id);
			});
			if (objIds.includes(this.id)) {
				this.id = Date.now() + parseInt(Math.random() * 10000);
			}

      this.$root.$on('setConfigElement', (id, obj) => {
        if(this.id == id){
          this.config = obj;
          this.internal_config = obj;
        }
			});

			this.$forceUpdate();
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .vdr {
    /*height: auto !important;*/
  }

  .preview-img {
    width: 100%;
    /*height: auto;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Webinar/Webinar.vue